import React, { useEffect, useState } from 'react'
import SimpleDialog from '../../Dialogs/SimpleDialog'
import NuevaFacturacion from '../NuevaFacturacion'
import { UrlApi } from '../../../services/apirest';
import * as api from "../api"
import {dePedidoARemito} from "../helpers"

function DialogNuevaFactContainer({open, setOpen, remitoSeleccionado}) {
    const [dataCliente, setDataCliente]=useState();
    const [dataRemito, setDataRemito] = useState(null);
    const [letra, setLetra]=useState();
    
    const rutasKeyMap = {
        1:{ruta: remitoSeleccionado.id_pedido ? "/pedidos/facturar-remito/" : "/remitos/facturar-remito/" , id: remitoSeleccionado.id_pedido ? "id_pedido" : "id_remito"},
        2:{ruta:"/remitos/facturar-remito/", id:"id_remito"},
        3:{ruta:"/remitos/facturar-remito/", id:"id_remito"},
    }

    const getDatosRemito = async () => {
        const params = rutasKeyMap[remitoSeleccionado.id_tipocliente];

        const ruta = `${UrlApi}${params.ruta}${remitoSeleccionado[params.id]}/${remitoSeleccionado.nro_remito}`

        const res = await fetch(ruta).then(data=>data.json()).then(data=>{
            return data;
        })
        
        let registroOriginal = await res[0];

        setDataCliente({
            id:registroOriginal?.id_cliente, 
            id_tipocliente:registroOriginal?.id_tipocliente,
            id_empresa:registroOriginal?.id_empresa_cliente,
            situacion_iva:registroOriginal?.situacion_iva,
            sucursal_cliente:registroOriginal?.sucursal_cliente,
            empresa_cliente:registroOriginal?.empresa_cliente,
            id_um_facturacion:registroOriginal?.cliente_id_um_facturacion ,
            descr_unidad: registroOriginal?.cliente_um_abrev,
            um_abrev: registroOriginal?.cliente_um_abrev,
            um_config:registroOriginal?.cliente_um_config,
            entrega_con_remito:registroOriginal?.entrega_con_remito,
            facturar_a: registroOriginal?.facturar_a,
            nombre_facturar_a:registroOriginal?.nombre_facturar_a
        })

        let remito = [];

        if(remitoSeleccionado.id_pedido){
            remito = dePedidoARemito([registroOriginal], registroOriginal?.id_empresa_cliente, registroOriginal?.id_unidad_medida)
        } else {
            remito = [registroOriginal];
        }

        setDataRemito(remito)

        if(registroOriginal?.situacion_iva) api.getLetra(registroOriginal?.situacion_iva, setLetra)
    }

    useEffect(()=>{
        getDatosRemito();
    },[])

    const Children = (
        <>
            {dataCliente && dataRemito && letra && (
                <NuevaFacturacion
                    origen={"listadoRemitos"}
                    dataCliente={dataCliente}
                    pedidosCliente={dataRemito}
                    rowSelection={{ 0: true }}
                    letra={letra}
                    handleClose={()=>setOpen(false)}
                />
              )
            }
        </>
    )

    return (
    <div>
        <SimpleDialog 
            width="xl"
            open={open}
            setOpen={setOpen}
            onClose={()=>setOpen(false)}
            // titulo={`Facturar Remito ${dataCliente?.facturar_a === null || dataCliente?.entrega_con_remito===0? "": `a: ${dataCliente?.nombre_facturar_a}`}`}
            titulo={`Facturar Remito ${dataCliente?.facturar_a === null || dataCliente?.entrega_con_remito===0? "": `a: ${dataCliente?.razon_social}`}`}

            subtitulo={`Remito N° ${remitoSeleccionado.nro_remito || remitoSeleccionado.nro}`}
            children={Children}
        />
    </div>
  )
}

export default DialogNuevaFactContainer;